import { CanvasJSON } from '@doer/frontend-components/creativity-editor';
import { buildPillPair } from '../../_shared/pills/pill-pair';
import { buildDiscountValue } from '../../_shared/text/discount-value';
import { buildBenefitLabel } from '../../_shared/pills/benefit-label';
import { buildPaymentMethodText } from '../../_shared/text/payment-method-text';
import { buildPaymentMethodHighlightText } from '../../_shared/text/payment-method-highlight-text';
import { buildLimitText } from '../../_shared/text/limit-text';
import { buildLegales } from '../../_shared/text/legales';
import { buildBackgroundImage } from '../../_shared/images/background-image';
import { buildWalletsGroup } from '../../_shared/images/wallets-group';
import { MACRO_MEDIA_BASE } from '../../_shared/data/media';

export const macroSelectaGlass1920x1920: CanvasJSON = {
  version: '7.1.0',
  objects: [
    {
      rx: 0,
      ry: 0,
      pieceId: 'background',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'left',
      originY: 'top',
      left: 0,
      top: 0,
      width: 1920,
      height: 1920,
      fill: '#000000d6',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    buildBackgroundImage({ canvasWidth: 1920, canvasHeight: 1920 }),

    // Overlay
    {
      kind: 'svg-url',
      src: `${MACRO_MEDIA_BASE}/templates/selecta-glass/overlay.svg`,
      originX: 'left',
      originY: 'top',
      left: -6392.349,
      top: -5652.1489,
      scaleX: 4.36,
      scaleY: 6.1714,
      blendMode: 'multiply',
      selectable: false,
      evented: false,
      clipPath: {
        type: 'Rect',

        version: '7.4.0',
        originX: 'center',
        originY: 'center',
        left: -67.205,
        top: 4.995,
        width: 1090.8,
        height: 1939.2,
        scaleX: 1,
        scaleY: 1,
        angle: 0,
        inverted: false,
        absolutePositioned: false
      }
    },

    // Shape glass
    {
      kind: 'svg-url',
      src: `${MACRO_MEDIA_BASE}/templates/selecta-glass/shape-v3.svg`,
      originX: 'center',
      originY: 'center',
      left: 960.2222,
      top: 1016.7856,
      targetWidth: 930,
      targetHeight: 1450
    },

    // Eliminar
    /* {
      cropX: 0,
      cropY: 0,
      layerId: 'bbee28da-f73b-4dd3-bd93-eb9b4b70e40b',
      selectable: false,
      evented: false,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      deletable: true,
      layerVisible: true,
      clipStart: 0,
      objectCaching: true,
      alphaFalloffEnabled: false,
      chromaKeyEnabled: false,
      type: 'Image',
      version: '7.4.0',
      originX: 'center',
      originY: 'center',
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      left: -986.0057,
      top: 959.2821,
      width: 1458,
      height: 1458,
      scaleX: 1.3159,
      scaleY: 1.3159,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${MACRO_MEDIA_BASE}/templates/selecta-glass/thumbnails/refe.png`,
      crossOrigin: null,
      filters: []
    }, */

    // Símbolo de porcentaje
    {
      pieceId: 'discount-value-symbol',
      fontSize: 87,
      fontWeight: 'normal',
      fontFamily: 'DM Sans',
      fontStyle: 'normal',
      lineHeight: 1.16,
      text: '%',
      charSpacing: 0,
      textAlign: 'center',
      styles: [],
      pathStartOffset: 0,
      pathSide: 'left',
      pathAlign: 'baseline',
      underline: false,
      overline: false,
      linethrough: false,
      textBackgroundColor: '',
      direction: 'ltr',
      textDecorationThickness: 66.667,
      minWidth: 20,
      splitByGrapheme: false,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Textbox',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 1310.4009,
      top: 469.4991,
      width: 97.7724,
      height: 87.01,
      fill: '#ffffff',
      stroke: null,
      strokeWidth: 1,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 1,
      scaleY: 1,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Doble pill
    buildPillPair({
      left: { pieceId: 'category', text: 'TRANSPORTE', style: 'white-black-text' },
      right: { pieceId: 'valid-days', text: 'Lunes a viernes', style: 'gold-white-text' },
      fontSize: 42,
      paddingX: 30,
      paddingY: 15,
      strokeWidth: 1.824,
      borderRadius: 40,
      position: { left: 960, top: 152.5975 }
    }),

    // Número de descuento
    buildDiscountValue({
      pieceId: 'discount-value',
      text: '30',
      fontSize: 610,
      fontWeight: 300,
      fill: '#ffffff',
      position: { left: 960, top: 643.4736, width: 782.4515, height: 689.3 }
    }),

    // Línea horizontal
    {
      pieceId: 'horizontal-line',
      rx: 0,
      ry: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Rect',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 960,
      top: 1407.2027,
      width: 140,
      height: 100,
      fill: 'rgb(255, 255, 255)',
      stroke: '#fff',
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 4.7973,
      scaleY: 0.0206,
      angle: 0,
      flipX: false,
      flipY: true,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0
    },

    // Pill con texto del beneficio
    buildBenefitLabel({
      pieceId: 'benefit-label',
      text: 'de ahorro',
      fontSize: 61,
      position: { left: 960, top: 948.6231 },
      paddingX: 31,
      paddingY: 15,
      pillFill: '#C9B787',
      borderRadius: 45
    }),

    // Texto del método de pago
    buildPaymentMethodText({
      pieceId: 'payment-method-text',
      text: 'Con todas tus tarjetas de Crédito Macro',
      fontSize: 60,
      lineHeight: 1.1,
      textAlign: 'center',
      fill: '#ffffff',
      position: { left: 960, top: 1150.3994, width: 750.106, height: 142.38 }
    }),

    // Texto adicional (mensaje MODO / celular)
    buildPaymentMethodHighlightText({
      pieceId: 'payment-method-highlight-text',
      text: 'Pagando con tu celular sin contacto',
      fontSize: 40,
      fill: '#ffffff',
      position: { left: 960, top: 1284.8386, width: 740, height: 48 }
    }),

    // Texto del tope
    buildLimitText({
      pieceId: 'limit-text',
      text: 'Tope $10.000 por cuenta, por mes.',
      fontSize: 42,
      fill: '#ffffff',
      position: { left: 960, top: 1444.529, width: 730, height: 22.6 }
    }),

    // Billeteras digitales (slots)
    buildWalletsGroup({ position: { left: 960, top: 1350.3127, height: 46 }, width: 397 }),

    // Logo Macro
    {
      cropX: 0,
      cropY: 0,
      selectable: true,
      evented: true,
      lockMovementX: false,
      lockMovementY: false,
      lockScalingX: false,
      lockScalingY: false,
      lockRotation: false,
      clipStart: 0,
      objectCaching: true,
      type: 'Image',
      version: '7.1.0',
      originX: 'center',
      originY: 'center',
      left: 960,
      top: 1657.9549,
      width: 8930,
      height: 3545,
      fill: 'rgb(0,0,0)',
      stroke: null,
      strokeWidth: 0,
      strokeDashArray: null,
      strokeLineCap: 'butt',
      strokeDashOffset: 0,
      strokeLineJoin: 'miter',
      strokeUniform: false,
      strokeMiterLimit: 4,
      scaleX: 0.0872,
      scaleY: 0.0872,
      angle: 0,
      flipX: false,
      flipY: false,
      opacity: 1,
      shadow: null,
      visible: true,
      backgroundColor: '',
      fillRule: 'nonzero',
      paintFirst: 'fill',
      globalCompositeOperation: 'source-over',
      skewX: 0,
      skewY: 0,
      src: `${MACRO_MEDIA_BASE}/logos/selecta-blanco.png`,
      crossOrigin: null,
      filters: []
    },

    // Texto con legales
    buildLegales({
      pieceId: 'legales',
      text: 'CARTERA CONSUMO',
      position: { left: 960, top: 1791.1869, width: 1830, height: 25.99 }
    })
  ],
  background: 'transparent'
};
